export interface Point {
  id: number;
  user_id: number;
  name: string;
  x: number;
  y: number;
  color: string;
  is_impassable: boolean;
  created_at: string;
  updated_at: string;
}

/**
 * Everything the world renderer draws. Comparing on these lets a WS snapshot
 * that repeats what we already hold keep the old array, so a viewport with tens
 * of thousands of points isn't rebuilt and rescanned for nothing.
 */
export const samePoint = (a: Point, b: Point): boolean =>
  a.x === b.x && a.y === b.y && a.color === b.color && a.is_impassable === b.is_impassable;